// extracted by mini-css-extract-plugin
export default {"modifyBtn":"AdminMobileCateList_modifyBtn__yP1JE","deleteBtn":"AdminMobileCateList_deleteBtn__6qwud"};